module.exports = __webpack_public_path__ + "static/img/third2_2_3.8c6e59ae.jpg";